<template>
  <v-main>
    <v-container fluid>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data() {
    return {}
  },

  components: {},

  methods: {},

  name: "Public",

  computed: {},

  watch: {},

  mounted: function() {
    console.log("mounted Public.vue")
  }
}
</script>

<style></style>
